<template>
  <div class="bg-white p-3 account-owner-wrap">
   
    <div class="rounded w-full mx-auto text-darkBlue mt-8 mb-8">
      

      <div class="px-6 mt-12">
        <p class="account-owner">Account Information</p>

        <div class="flex justify-between px-3 mt-4">
          <div class="">
            <image-uploader
             :saveClosed="saveClosedOrg"
              ref="fileInput"
              :imageUrl="organization.orgimage ? organization.orgimage : '' "
              @input="uploadImage($event)"
              @remove-image="removeImage"
              :isUploadingImage="isUploadingImage"
              
            />
          </div>

          <div class="mt-5 flex justify-start gap-4">
            <base-button
              text="Edit"
              background="#10233E"
              color="text-white"
              width="250px"
              heigth="50px"
              p="py-2 px-8"
              @click="openEditOrg"
              v-if="saveClosedOrg"
            />

            <base-button
              text="Save"
              width="250px"
              heigth="50px"
              p="py-2 px-8"
              :loading="loadingOrg"
              @click="updateOrganization"
              v-if="editClosedOrg"
            />
          </div>
        </div>

        <form @submit.prevent class="py-12 px-2">
          <div class="">
            <div class="row mt-3">
              <div class="col-12 col-md-12 col-lg-6">
                <div class="px-3">
                  <label class="label">Organization Name</label>
                  <base-input :disabled="!editClosedOrg" v-model="organization.companyname" />
                </div>
              </div>
              <div class="col-12 col-md-12 col-lg-6">
                <div class="px-3">
                  <label class="label">Domain Name</label>
                  <base-input :disabled="!editClosedOrg" v-model="organization.customdomain" />
                </div>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-12 col-md-12 col-lg-6">
                <div class="px-3">
                  <label class="label">Organizational Identifier</label>
                  <el-select
                    filterable
                    v-model="organization.industry"
                    placeholder="Select"
                    @change="removeSelectedSpecialization"
                    :disabled="!editClosedOrg"
                  >
                    <el-option
                      v-for="industry in industries"
                      :key="industry"
                      :label="industry"
                      :value="industry"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="col-12 col-md-12 col-lg-6">
                <div class="px-3">
                  <label class="label">Sector</label>
                  <el-select
                    filterable
                    v-model="organization.specialization"
                    placeholder="Select"
                    :disabled="!editClosedOrg"
                  >
                    <el-option
                      v-for="specialization in filteredSpecializations"
                      :key="specialization"
                      :label="specialization"
                      :value="specialization"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-12 col-md-12 col-lg-6">
                <div class="px-3">
                  <label class="label">Incorporation Type</label>
                  <base-input :disabled="!editClosedOrg" v-model="organization.incorporationType" />
                </div>
              </div>

              <div class="col-12 col-md-12 col-lg-6">
                <div class="px-3">
                  <label class="label">Incorporation Status</label>
                  <base-input :disabled="!editClosedOrg" v-model="organization.incorporationStatus" />
                </div>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-12 col-md-12 col-lg-6">
                <div class="px-3">
                  <label class="label">CAC Incorporation Number</label>
                  <base-input :disabled="!editClosedOrg" v-model="organization.incorporationNumber" />
                </div>
              </div>

              <div class="col-12 col-md-12 col-lg-6">
                <div class="px-3">
                  <div class="w-full flex">
                    <label class="label whitespace-no-wrap">Mobile Number</label>
                    <div class="w-full flex gap-4 justify-end">
                      <div class="single-option">
                        <label for="firstYes" class="radio-label">
                          <input
                            class="bg-primary-yellow text-secondary-yellow"
                            name="first"
                            type="radio"
                            id="firstYes"
                            value="Mobile"
                            v-model="numberType"
                          />
                          Mobile
                          <span></span>
                        </label>
                      </div>

                      <div class="single-option">
                        <label for="firstNo" class="radio-label">
                          <input
                            type="radio"
                            v-model="numberType"
                            value="Fixed"
                            id="firstNo"
                            name="first"
                          />
                          Fixed
                          <span></span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <vue-tel-input
                    :allowNumericInput="false"
                    @input="phoneNumberChange"
                    :preferredCountries="['Nigeria']"
                    :disabled="!editClosedOrg"
                    v-model="organization.mobile_no"
                  ></vue-tel-input>
                </div>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-12 col-md-12 col-lg-6">
                <div class="px-3">
                  <div class="flex items-center">
                    <label class="label">Address</label>
                  </div>

                  <vue-google-autocomplete
                    id="map2"
                    ref="address"
                    classname="input"
                    placeholder="Enter address"
                    :disabled="!editClosedOrg"
                    :value="fullAddress2"
                    v-on:placechanged="setAddress2"
                  >
                  </vue-google-autocomplete>
                </div>
              </div>

              <div class="col-12 col-md-12 col-lg-6">
                <div class="px-3">
                  <label class="label">Email Address</label>
                  <base-input
                    :disabled="true"
                    class="cursor-not-allowed text-gray-600"
                    v-model="organization.email"
                  />
                </div>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-12 col-md-12 col-lg-6">
                <div class="px-3">
                  <label class="label">Web</label>
                  <base-input :disabled="!editClosedOrg" v-model="organization.web" />
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <picture-modal
      :image="getProfileImage"
      @completed-picture-update="findUserDetails"
      :showModal="showPictureModal"
      @close-modal="showPictureModal = false"
    />
  </div>
</template>

<script>
import {
  organizationTypes,
  industries,
  specializations,
} from "@/utilities/globalVariables";
// import PageHeader from "@/components/Ondemand/PageHeader.vue";
import VueGoogleAutocomplete from "vue-google-autocomplete";
// import timezones from "@/utilities/timezones";
import PictureModal from "@/components/Ondemand/Settings/PictureModal.vue";
import ImageUploader from "@/components/EnterpriseCustomer/Settings/ImageUploader";

export default {
  components: {
    // PageHeader,
    VueGoogleAutocomplete,
    PictureModal,
    ImageUploader
  },
  data() {
    return {
      // accountOwner: {
      //   address: {
      //     name: "",
      //     lat: "",
      //     lng: "",
      //     street_number: "",
      //     adm_1: "",
      //     adm_2: "",
      //   },
      //   firstname: "",
      //   lastname: "",
      //   gender: "",
      //   mobile_no: "",
      //   email: "",
      //   imageurl: "",
      //   country: "",
      // },
      organization: {
        id: "",
        companyname: "",
        address: {},
        type: "",
        country: "",
        stateId: "",
        city: "",
        industry: "",
        specialization: "",
        incorporationStatus: "",
        incorporationNumber: "",
        incorporationType: "",
        mobile_no: "",   
        orgimage: "",
        customdomain: "",
        regnumber: "",
        email: "",
        web: "",
        facebook: "",
        instagram: "",
        linkedin: "",
        twitter: "",
        language: "",
        orgTimezone: "",
      },
      numberType: "mobile",
      orgImage: "",
      organizationTypes: organizationTypes,
      industries: industries,
      specializations: specializations,
      genders: ["Male", "Female"],
      languages: ["English"],
      loading: false,
      savingAccountOwnerInfo: false,
      totalSteps: "3",
      stepNo: "3",
      accountType: null,
      isUploadingImage: false,
      showPictureModal: false,
      saveClosed: true,
      editClosed: false,
      saveClosedOrg: true,
      editClosedOrg: false,
      loadingOrg : false
    };
  },
  watch : {
    "organization.companyname"(v) {
      this.organization.customdomain = v
        .trim()
        .replace(/\s+/g, "-")
        .toLowerCase();
    },
  },
  computed: {
    fullAddress() {
      return this.extractAddress(this.accountOwner.address);
    },
    fullAddress2() {
      return this.extractAddress(this.organization.address);
    },
    getProfileImage() {
      return this.organization.orgimage != " "
        ? this.organization.orgimage
        : require("@/assets/images/settings/img-placeholder.png");
      // return this.accountOwner.imageurl ;
    },
    filteredSpecializations() {
      let indexOfSelectedIndustry = this.industries.indexOf(this.organization.industry);
      if (indexOfSelectedIndustry >= 0) {
        return this.specializations[indexOfSelectedIndustry];
      } else {
        return [];
      }
    },
  },
  mounted() {
    this.findUserDetails();

    const organization = JSON.parse(localStorage.getItem("organizationDetails"));

    this.selectedIndustry = this.organization.industry;
    this.organization.id = organization.id;
    this.organization.companyname = organization.companyname;
    this.organization.type = organization.type;
    this.organization.customdomain = organization.customdomain;
    this.organization.regnumber = organization.regnumber;
    this.organization.address = organization.address;
    this.organization.country = organization.country;
    this.organization.stateId = organization.stateId;
    this.organization.city = organization.city;
    this.organization.email = organization.email;
    this.organization.industry = organization.industry;
    this.organization.specialization = organization.specialization;
    this.organization.mobile_no = organization.mobile_no;
    this.organization.orgimage = organization.orgimage;
    this.organization.web = organization.web;
    this.organization.facebook = organization.facebook;
    this.organization.instagram = organization.instagram;
    this.organization.linkedin = organization.linkedin;
    this.organization.twitter = organization.twitter;
    (this.organization.language = organization.language),
      (this.organization.orgTimezone = organization.orgTimezone);
  },
  methods: {
    openEdit() {
      this.saveClosed = false;
      this.editClosed = true;
    },
    openEditOrg() {
      this.saveClosedOrg = false;
      this.editClosedOrg = true;
    },
    selectImage() {
        this.$refs.fileInput.click();
    },
    phoneNumberChange(val) {
      const pattern = /[a-zA-Z!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]/g;
      const result = val.replace(pattern, "");
      this.$nextTick(() => {
        this.accountOwner.mobile_no = result;
      });
    },
    async findUserDetails() {
      try {
        let response = await this.$_findUserDetails();
        this.organization = response.data.data.Org;
      } catch (error) {
        this.handleError(error);
        this.loading = false;
      }
    },
    
    deleteExcessData() {
      // removes the unneeded properties from the user object
      delete this.accountOwner.Org;
      delete this.accountOwner.createdAt;
      delete this.accountOwner.passwordauth;
      delete this.accountOwner.updatedAt;
      delete this.accountOwner.twoFA;
      delete this.accountOwner.securityques;
      delete this.accountOwner.onboardingtype;
      delete this.accountOwner.salt;
      delete this.accountOwner.hash;
      delete this.accountOwner.accounttype;
      delete this.accountOwner.answer;
    },
    setAddress(addressData) {
      this.accountOwner = {
        ...this.accountOwner,
        address: {
          name: addressData?.route,
          lat: addressData?.latitude,
          lng: addressData?.longitude,
          street_number: addressData?.street_number,
          locality: addressData?.locality,
          country: addressData.country,
          adm_1: addressData?.administrative_area_level_1,
          adm_2: addressData?.administrative_area_level_2,
        },
      };
      console.log(this.accountOwner);
    },
    setAddress2(addressData) {
      this.organization = {
        ...this.organization,
        address: {
          name: addressData?.route,
          lat: addressData?.latitude,
          lng: addressData?.longitude,
          street_number: addressData?.street_number,
          locality: addressData?.locality,
          country: addressData.country,
          adm_1: addressData?.administrative_area_level_1,
          adm_2: addressData?.administrative_area_level_2,
        },
      };
      console.log(this.organization);
    },
    async updateOrganization() {
      this.loadingOrg = true;
      this.organization.orgId = localStorage.getItem("organizationId");

      let payload = {
        org: {
          ...this.organization,
        },
      };

      try {
        await this.$_updateOrganizationInformation(payload);

        localStorage.removeItem("organizationDetails");
        localStorage.setItem(
          "organizationDetails",
          JSON.stringify(this.organization)
        );
        // this.organization =
        this.generateToast("Organization Details successfully updated!", "success");
        this.loadingOrg = false;
        this.saveClosedOrg = true;
        this.editClosedOrg = false;
        // this.$router.push({ name: "AccountProfile" });
      } catch (error) {
        this.handleError(error);
        this.loadingOrg = false;
      }
    },
    removeSelectedSpecialization() {
      this.organization.specialization = "";
    },
    async uploadImage(image) {
      this.isUploadingImage = true;
      const formData = new FormData();
      formData.append("file", image);
      formData.append("upload_preset", "zunt8yrw");

      try {
        let response = await this.$_uploadImage(formData);
        this.organization.orgimage = response.data.fileUrl;
        this.generateToast("Image uploaded", "success");
        this.isUploadingImage = false;
      } catch (error) {
        this.handleError(error);
        this.isUploadingImage = false;
      }
    },
    removeImage() {
      this.organization.orgimage = null;
    },
  },
};
</script>

<style scoped>
.account-owner-wrap{
  /* border: 1px solid blue; */
  border-radius: 8px;
   box-shadow: 0px 4px 6px #00000014;
}
.account-owner{
  color: #10233E;
  font-size: 20px;
  font-weight: 600;
}
.banner {
  width: 100%;
  height: 9rem;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  @apply bg-primary-navy;
}

.imagePreviewWrapper {
  position: relative;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  display: block;
  cursor: pointer;
  border: 4px solid white;
  /* margin: 0 auto; */
  background-size: cover;
  background-position: center center;
}

.img-upload-icon {
  position: absolute;
  @apply cursor-pointer;
  right: 0;
  top: -2rem;
}
</style>
